import { SESSION_REPLAY_EXCLUDED_COUNTRIES, SESSION_REPLAY_UNVERIFIED_COUNTRY_CODES } from '../constants';

const ISO_ALPHA2_PATTERN = /^[A-Z]{2}$/;

/**
 * Returns true when Session Replay is allowed to initialize for the given
 * country code. Fails closed for unknown / undefined codes so we never start
 * recording in a region we cannot verify.
 */
export function isSessionReplayAllowedForCountry(countryCode: string | null | undefined): boolean {
  if (!countryCode) return false;

  const normalized = countryCode.trim().toUpperCase();
  if (!ISO_ALPHA2_PATTERN.test(normalized)) return false;
  if ((SESSION_REPLAY_UNVERIFIED_COUNTRY_CODES as readonly string[]).includes(normalized)) return false;

  return !(SESSION_REPLAY_EXCLUDED_COUNTRIES as readonly string[]).includes(normalized);
}
